/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import {
	ChangeDetectionStrategy,
	Component,
	input
} from "@angular/core";
import type { FloatingComponent } from "../../floating-component";

@Component({
	selector: "cb-tooltip",
	templateUrl: "./tooltip.component.html",
	styleUrl: "./tooltip.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TooltipComponent implements FloatingComponent {
	/**
	 * The content of the tooltip.
	 */
	public readonly content = input("");

	/**
	 * The position of the tooltip.
	 */
	public readonly position = input<"top" | "bottom" | "left" | "right">("left");

	/**
	 * The style of the tooltip.
	 */
	public readonly style = input<"dark" | "light">("dark");

	/**
	 * The description of the tooltip.
	 */
	public readonly description = input("");

	/**
	 * The left position of the tooltip.
	 */
	public readonly leftPosition = input(0);

	/**
	 * The top position of the tooltip.
	 */
	public readonly topPosition = input(0);

	/**
	 * The alignment of the tooltip.
	 */
	public readonly alignment = input<"start" | "center" | "end">("center");
}
